import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const MessagingRulesPage = lazy(() => import('./MessagingRulesPage'));

const MessagingRulesConfig = {
  settings: {
    layout: {},
  },
  auth: AuthRoles.MessagingConfig,
  routes: [
    {
      path: 'messaging-rules',
      element: <MessagingRulesPage />,
    },
  ],
};

export default MessagingRulesConfig;
